import SjPanel from '@/components/SjPanel'
import SjExportXlsxBox from '@/components/SjExportXlsxBox'

Vue.component(SjPanel.name, SjPanel)
Vue.component(SjExportXlsxBox.name, SjExportXlsxBox)

Vue.prototype.$export = {
  xlsx: SjExportXlsxBox.open,
}
